(() => {
  const initialize = (dialog) => {
    if (dialog.dataset.searchDialogReady === 'true') return;

    dialog.dataset.searchDialogReady = 'true';
    const dialogId = dialog.id;
    const section = dialog.closest('.shopify-section');
    const openButton = section?.querySelector(`[aria-controls="${dialogId}"]`);
    const closeButton = dialog.querySelector('[data-site-search-close]');
    const searchInput = dialog.querySelector('[data-site-search-input]');
    const suggestions = dialog.querySelector('[data-site-search-suggestions]');
    const suggestionItems = Array.from(dialog.querySelectorAll('[data-site-search-suggestion]'));

    const normalize = (value) =>
      value
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

    const updateSuggestions = () => {
      const query = normalize(searchInput?.value || '');
      let visibleCount = 0;

      suggestionItems.forEach((item) => {
        const brand = normalize(item.dataset.brandName || '');
        const isVisible = query.length > 0 && brand.includes(query) && visibleCount < 6;
        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (suggestions) suggestions.hidden = visibleCount === 0;
    };

    openButton?.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
        window.requestAnimationFrame(() => searchInput?.focus());
      }
    });

    closeButton?.addEventListener('click', () => dialog.close());
    searchInput?.addEventListener('input', updateSuggestions);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      if (searchInput) searchInput.value = '';
      updateSuggestions();
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-site-search-dialog]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
